'use client';

import { usePathname, useRouter } from 'next/navigation';

import { isEmpty } from 'lodash';

interface PropsQueryRegister {
  pathname?: string;
  query?: Record<string, string | number | boolean>;
  loginMethod: string;
}

export const useRegisterQueryParams = () => {
  const router = useRouter();
  const currentPathname = usePathname();

  const addQuery = ({
    pathname = currentPathname,
    query = {},
    loginMethod,
  }: PropsQueryRegister) => {
    const params = new URLSearchParams();

    if (!isEmpty(query)) {
      Object.entries(query).forEach(([key, value]) => {
        params.set(key, String(value));
      });
    }

    params.set('utm_register_method', loginMethod);

    const newUrl = `${pathname}?${params.toString()}`;

    router.replace(newUrl);
  };

  return addQuery;
};
